import { style } from 'typestyle';
import { 
    COLOR_24,
    COLOR_37,
    FONT_MAIN,
    FONT_WEIGHT_REGULAR,
    MARGINS_PX
} from '../../../constants';
import { styleOverride, tabletStyles } from '../../../utils';

export const pageSectionClassName = style({
    $debugName: 'pageSection.component',
    
    display: 'block',
    padding: `${MARGINS_PX * 2}px 0`
});

export const pageSectionHeadClassName = style({
    display: 'block'
}, tabletStyles({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap'
}));

export const pageSectionHeadTitleClassName = style({
    display: 'block',
    padding: `0 0 ${MARGINS_PX * 2}px 0`,
    fontSize: '22px',
    lineHeight: '25.5px',
    fontFamily: FONT_MAIN,
    fontWeight: FONT_WEIGHT_REGULAR
}, tabletStyles({
    flexGrow: 1,
    flexShrink: 1,
    fontSize: '32px',
    lineHeight: '37.5px'
}));

export const pageSectionHeadAsideClassName = style({
    display: 'block',
    padding: `0 0 ${MARGINS_PX * 2}px 0`
});

export const pageSectionInnerClassName = style({
    display: 'block'
});

export const pageSectionThemeBlueClassName = styleOverride(
    null,
    [pageSectionHeadTitleClassName, {color: COLOR_24}]
);

export const pageSectionThemeGreenClassName = styleOverride(
    null,
    [pageSectionHeadTitleClassName, {color: COLOR_37}]
);